module.exports = __webpack_public_path__ + "img/barrage_prize_11.7f67b81a.png";